import { array, object } from 'yup';

export const schema = object({
	folder: object().required(),
	users: array().nullable(),
	milestones: array().nullable(),
});
